// extracted by mini-css-extract-plugin
export default {"link":"Herocrypto_link__04X4G","container":"Herocrypto_container__RX0JZ","name":"Herocrypto_name__nLLTV","value":"Herocrypto_value__BBVIK"};